"use strict";
/**
 * @module Routing
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var topic_cache_datatype_entry_1 = require("./../routing/topic-cache-datatype-entry");
var time_series_event_datatype_1 = require("./../timeseries/time-series-event-datatype");
/**
 * Extends {@link DatatypeCacheEntry} to handle time series events with a given
 * data type
 */
var TimeSeriesCacheEntry = /** @class */ (function (_super) {
    __extends(TimeSeriesCacheEntry, _super);
    /**
     * Create a new TimeSeriesCacheEntry instance
     *
     * @param streams        the stream adapters
     * @param path           the topic path
     * @param specification  the topic specification
     * @param datatype       the data type of the entry
     */
    function TimeSeriesCacheEntry(streams, path, specification, datatype) {
        return _super.call(this, streams, path, specification, time_series_event_datatype_1.TimeSeriesEventDataType.create(datatype)) || this;
    }
    return TimeSeriesCacheEntry;
}(topic_cache_datatype_entry_1.DatatypeCacheEntry));
exports.TimeSeriesCacheEntry = TimeSeriesCacheEntry;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/routing/topic-cache-time-series-entry.js
// module id = 1486
// module chunks = 1